<script lang="ts">
	import { ModeWatcher } from 'mode-watcher';
	import Footer from '$lib/components/Footer.svelte';
	import Navigation from '$lib/components/Navigation.svelte';
	import PageTransition from '$lib/components/PageTransition.svelte';
	import { Toaster } from '$lib/components/ui/sonner';
	import '../app.pcss';
	import ThirdPartyScripts from '$lib/components/ThirdPartyScripts.svelte';

	let { data, children } = $props();
</script>

<ThirdPartyScripts />
<ModeWatcher defaultMode={'light'} />
<Toaster />
<Navigation />
<PageTransition key={data.url}>
	<main>
		{@render children?.()}
	</main>
</PageTransition>
<Footer />
